// Time slots: 08:00 → 23:00 start (16 rows total, last row labeled 23:00-00:00)
export const TIME_SLOTS = Array.from({ length: 16 }, (_, i) => {
  const startH = 8 + i;
  const endH = (startH + 1) % 24;
  const fmt = (h) => `${String(h).padStart(2, '0')}:00`;
  return {
    label: `${fmt(startH)}-${fmt(endH)}`,
    start_hour: startH,
    short: `${fmt(startH)}`,
  };
});

// Map of sport → tailwind classes for cell coloring (light tones, easy on eyes)
export const SPORT_STYLES = {
  pickleball: {
    bg: 'bg-red-100',
    text: 'text-red-900',
    border: 'border-red-500',
    badge: 'bg-red-200 text-red-900',
    label: 'Pickleball',
  },
  badminton: {
    bg: 'bg-amber-100',
    text: 'text-amber-900',
    border: 'border-amber-500',
    badge: 'bg-amber-200 text-amber-900',
    label: 'Badminton',
  },
};

export const SPORT_FALLBACK = {
  bg: 'bg-gray-100',
  text: 'text-gray-700',
  border: 'border-gray-500',
  badge: 'bg-gray-200 text-gray-700',
  label: 'Court',
};

export const STATUS_TEXTURE = {
  CONFIRMED: '', // solid fill, no extra
  AWAITING_PAYMENT:
    'bg-[repeating-linear-gradient(45deg,_transparent,_transparent_6px,_rgba(255,255,255,0.55)_6px,_rgba(255,255,255,0.55)_10px)]',
};
